import facebook from "../images/Social/facebook.webp";
import whatsapp from "../images/Social/whatsapp.webp";
import gmail from "../images/Social/gmail.webp";
import github from "../images/Social/github.webp";
import linkedin from "../images/Social/linkedin.webp";
import instagram from "../images/Social/instagram.webp";

export const socialLinks = [
  {
    link: "https://www.linkedin.com/in/emon-singha209/",
    image: linkedin,
    name: "linkedin",
  },
  {
    link: "https://github.com/emonsingha209",
    image: github,
    name: "github",
  },
  {
    link: "https://www.facebook.com/thounaojam.emon",
    image: facebook,
    name: "facebook",
  },
  {
    link: "https://www.instagram.com/thounaojam_emon/",
    image: instagram,
    name: "instagram",
  },
  {
    link: "https://wa.me/+8801743217209",
    image: whatsapp,
    name: "whatsapp",
  },
  {
    link: "mailto:emonsingha209@gmail.com",
    image: gmail,
    name: "gmail",
  },
];
